import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const BlueTypography = withStyles({
  root: {
    color: '#0b72b9',
  },
})(Typography);
